import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { StickyContainer as ReactStickyContainer } from 'react-sticky';

import type { IStickyContainerDeps, IStickyContainerProps } from './models';
import { StickyContainer as Component } from './sticky-container';

export const StickyContainer = createWidget<IStickyContainerDeps, IStickyContainerProps>({
    ReactStickyContainer,
})(Component);
